var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","flex-wrap":"nowrap","align-items":"center","justify-content":"flex-start"}},[_c('div',{staticClass:"short-name-wrapper",attrs:{"title":_vm.value}},[_c('span',{staticClass:"short-name"},[_vm._v(_vm._s(_vm.value || _vm.header.placeholder))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }